// extracted by mini-css-extract-plugin
module.exports = {"paymentMethodSection":"PaymentMethod_paymentMethodSection__12Qqv","subtitle":"PaymentMethod_subtitle__35Blv","paymentMethodItem":"PaymentMethod_paymentMethodItem__1MO9L"};